import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  fill: "none",
  stroke: "currentColor",
  "stroke-linecap": "round",
  "stroke-linejoin": "round",
  "stroke-width": "2.5",
  viewBox: "0 0 64 64"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, [...(_cache[0] || (_cache[0] = [
    _createElementVNode("rect", {
      width: "28",
      height: "52",
      x: "18",
      y: "6",
      rx: "4"
    }, null, -1),
    _createElementVNode("path", { d: "M28 52h8" }, null, -1),
    _createElementVNode("circle", {
      cx: "32",
      cy: "12",
      r: "1",
      fill: "currentColor"
    }, null, -1)
  ]))]))
}
export default { render: render }